import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { config } from 'config';

export interface SendOtpRequest {
  type: string;
  email: string;
  id?: string;
}

export interface VerifyOtpRequest {
  email: string;
  otp: string;
  type: string;
  id?: string;
}

export interface ApiResponse {
  success: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class OtpService {
  private readonly baseUrl = '/api';

  constructor(private http: HttpClient) {}

  sendOtp(request: SendOtpRequest): Observable<ApiResponse> {
    const url = `${config.apiUrl1}send-otp`;
    return this.http.post<ApiResponse>(url, request);
  }

  verifyOtp(request: VerifyOtpRequest): Observable<ApiResponse> {
    const url = `${config.apiUrl1}verify-otp`;
    return this.http.post<ApiResponse>(url, request);
  }
}